// @flow
import React from 'react';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import SizeGridToken from './SizeGridToken';

type Props = {
  modifiers: Array<string>,
};

const messages = defineMessages({
  'in-stock': { id: 'size-grid.in-stock', defaultMessage: 'In stock' },
  'low-stock': { id: 'size-grid.low-stock', defaultMessage: 'Low in stock' },
  'pre-order': {
    id: 'size-grid.pre-order',
    defaultMessage: 'Available for pre-order',
  },
  'no-stock': { id: 'size-grid.no-stock', defaultMessage: 'Out of stock' },
});

const SizeGridKey = (props: Props) => (
  <div className="c-size-grid__key">
    {props.modifiers.map((modifier, index) => (
      <div key={index} className="c-size-grid__key__item">
        {modifier === 'no-stock' ? (
          <SizeGridToken noStock />
        ) : (
          <SizeGridToken modifier={modifier} />
        )}
        <FormattedMessage {...messages[modifier]} />
      </div>
    ))}
  </div>
);

export default injectIntl(SizeGridKey);
